import { addDays, format, getYear } from "date-fns";

export interface StandardHoliday {
  nameLt: string;
  nameEn: string;
  month: number; // 1-indexed
  day: number;
}

const FIXED_HOLIDAYS: StandardHoliday[] = [
  { month: 1, day: 1, nameLt: "Naujieji metai", nameEn: "New Year's Day" },
  { month: 2, day: 16, nameLt: "Lietuvos valstybės atkūrimo diena", nameEn: "Restoration of the State of Lithuania" },
  { month: 3, day: 11, nameLt: "Lietuvos nepriklausomybės atkūrimo diena", nameEn: "Restoration of Independence of Lithuania" },
  { month: 5, day: 1, nameLt: "Tarptautinė darbo diena", nameEn: "International Workers' Day" },
  { month: 6, day: 24, nameLt: "Joninės (Rasos)", nameEn: "St. John's Day" },
  { month: 7, day: 6, nameLt: "Valstybės (Lietuvos karaliaus Mindaugo karūnavimo) diena", nameEn: "Statehood Day" },
  { month: 8, day: 15, nameLt: "Žolinė (Švč. Mergelės Marijos ėmimo į dangų diena)", nameEn: "Assumption Day" },
  { month: 11, day: 1, nameLt: "Visų šventųjų diena", nameEn: "All Saints' Day" },
  { month: 11, day: 2, nameLt: "Vėlinės", nameEn: "All Souls' Day" },
  { month: 12, day: 24, nameLt: "Kūčios", nameEn: "Christmas Eve" },
  { month: 12, day: 25, nameLt: "Kalėdos", nameEn: "Christmas Day" },
  { month: 12, day: 26, nameLt: "Kalėdų antroji diena", nameEn: "Boxing Day" },
];

/**
 * Calculates Easter Sunday for a given year using Anonymous Gregorian algorithm.
 */
function getEasterSunday(year: number): Date {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

export function getPublicHolidaysForYear(year: number) {
  const holidays: { title: string; startDate: string; endDate: string }[] = [];

  // Fixed
  FIXED_HOLIDAYS.forEach((h) => {
    const dateStr = format(new Date(year, h.month - 1, h.day), "yyyy-MM-dd");
    holidays.push({
      title: h.nameLt,
      startDate: dateStr,
      endDate: dateStr,
    });
  });

  // Easter Sunday & Monday
  const easterSunday = getEasterSunday(year);
  const easterMonday = addDays(easterSunday, 1);

  holidays.push({
    title: "Velykos",
    startDate: format(easterSunday, "yyyy-MM-dd"),
    endDate: format(easterSunday, "yyyy-MM-dd"),
  });
  holidays.push({
    title: "Velykų antroji diena",
    startDate: format(easterMonday, "yyyy-MM-dd"),
    endDate: format(easterMonday, "yyyy-MM-dd"),
  });

  // Sort by date
  return holidays.sort((a, b) => a.startDate.localeCompare(b.startDate));
}
